import React, { useState } from 'react';
import { Link } from "react-router-dom";
import {  useDispatch } from "react-redux";
import {PlusCircle,} from "react-feather";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import AddUsers from "../../core/modals/usermanagement/addusers";
import EditUser from "../../core/modals/usermanagement/edituser";
import { deleteUser } from "../../api/manageUser";
import { removeUser } from "../../slices/userSlice";
import useProducts from "../../hooks/useProducts";

const Users = () => {
  const dispatch = useDispatch();
 
  const { users } = useProducts();

  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null); 

  const deleteFunction = async (userId) => {
    try {
      const response = await deleteUser(userId);
  
      if (response?.error) {
        // Gestion des erreurs retournées par le serveur
        Swal.fire("Erreur", response.error.message || "Une erreur est survenue.", "error");
      }else{
        Swal.fire("Supprimé !", "Utilisateur supprimé avec succès.", "success");

      }


    } catch (error) {
      // Gestion des erreurs inattendues (réseau, serveur non joignable, etc.)
      Swal.fire(
        "Erreur",
        error?.response?.data?.message || "Une erreur imprévue est survenue.",
        "error"
      );
    }
  };

  const columns = [
    {
      title: "Nom d'utilisateur",
      dataIndex: "name",
      
      sorter: (a, b) => a.username.length - b.username.length,
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length,
    },
    { title: "Role", dataIndex: "role", render: (role) => role?.name || "Non défini" },
    {
      title: "Créé le",
      dataIndex: "created_at",
      render: (text, record) => {
        // Formatage de la date selon le format français (ex: 3 février 2025)
        return new Date(record.created_at).toLocaleDateString('fr-FR', { 
          day: 'numeric', 
          month: 'long', 
          year: 'numeric' 
        });
      },
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
    }, 
    {
      title: "Status",
      dataIndex: "status",
      render: ( text = "Active") => (
        <div>
          {text === "Active" && (
            <span className="badge badge-linesuccess">{text}</span>
          )}
          {text === "Inactive" && (
            <span className="badge badge-linedanger">{text}</span>
          )}
        </div>
      ),
      sorter: (a, b) => a.status.length - b.status.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
           
            <button
              className="btn btn-sm btn-primary me-2"
              data-bs-toggle="modal"
              data-bs-target="#edit-units"
              onClick={() => handleEdit(record)}

            >
              <i data-feather="edit" className="feather-edit"></i>
            </button>
            <Link className="confirm-text p-2" to="#">
              <i
                data-feather="trash-2"
                className="feather-trash-2"
                onClick={() => showConfirmationAlert(record.id)}

              ></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Es-tu sûr?",
      text: "Vous ne pourrez pas revenir en arrière !",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Oui, supprimez-le !",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Retour",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteFunction(id);
         
        dispatch(removeUser(id)); 
        
       
      } else {
        MySwal.close();
      }
    });
  };

  // Gestion de l'ouverture de l'éditeur
  const handleEdit = (user) => {

    setSelectedUser(user);

    setIsEditModalVisible(true);
    
  };
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Liste des utilisateurs</h4>
                <h6>Gérer vos utilisateurs</h6>
              </div>
            </div>
           
            <div className="page-btn">
              <a
                to="#"
                className="btn btn-added"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
              >
                <PlusCircle className="me-2" />
                Ajouter un nouvel utilisateur
              </a>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
               
               
              </div>
           
              <div className="table-responsive">
                <Table columns={columns} dataSource={users} />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <AddUsers />
       {isEditModalVisible && (
          <EditUser
            user={selectedUser}
            onClose={() => setIsEditModalVisible(false)}
          />
        )}
    </div>
  );
};

export default Users;
